import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { AxiosRequestConfig } from "axios";
import { VenueBasedSeatPermissionsSerializer } from "../types/seating-types";

export default class VenueBasedSeatPermissionsRepository extends Repository<VenueBasedSeatPermissionsSerializer> {
  public readonly repositoryName = "VenueBasedSeatPermissionsRepository";

  public readonly endpoint = venueBasedUrl(
    "events/ticket-types/seats/permissions/"
  );

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      reservedSeatPermissions: "reserved-seats/",
    };
  }

  public async getReservedPermissions(
    venueId: number,
    config: AxiosRequestConfig
  ) {
    const { data } = await this.request(
      this.buildUrl("reservedSeatPermissions", { venueId }),
      config
    );
    return data;
  }
}
